import * as Types from '../types';

import gql from 'graphql-tag';
export type LegacyPrematchBetFragment = { __typename?: 'Bet', id: string, actor: string, amount: string, status: Types.BetStatus, potentialPayout: string, payout?: string | null, result?: Types.BetResult | null, odds: string, settledOdds?: string | null, redeemedTxHash?: string | null, affiliate?: string | null, isRedeemed: boolean, isRedeemable: boolean, isCashedOut: boolean, tokenId: string, createdAt: string, resolvedAt?: string | null, txHash: string, redeemedAt?: string | null, core: { __typename?: 'CoreContract', address: string, liquidityPool: { __typename?: 'LiquidityPoolContract', address: string } }, selections: Array<{ __typename?: 'Selection', odds: string, result?: Types.SelectionResult | null, outcome: { __typename?: 'Outcome', outcomeId: string, title?: string | null, condition: { __typename?: 'Condition', conditionId: string, status: Types.ConditionStatus, title?: string | null, wonOutcomeIds?: Array<string> | null, game: { __typename?: 'Game', id: string, gameId: string, title?: string | null, startsAt: string, status: Types.GameStatus, slug?: string | null, sport: { __typename?: 'Sport', sportId: string, slug: string, name: string, sporthub: { __typename?: 'SportHub', id: string, slug: string } }, league: { __typename?: 'League', id: string, slug: string, name: string, country: { __typename?: 'Country', id: string, slug: string, name: string } }, participants: Array<{ __typename?: 'Participant', image?: string | null, name: string }> } } } }>, freebet?: { __typename?: 'Freebet', freebetId: string, contractAddress: string } | null, cashout?: { __typename?: 'Cashout', payout: string } | null };

export const LegacyPrematchBetFragmentDoc = gql`
    fragment LegacyPrematchBet on Bet {
  id
  tokenId: betId
  actor
  amount
  status
  potentialPayout
  payout
  result
  odds
  settledOdds
  createdAt: createdBlockTimestamp
  resolvedAt: resolvedBlockTimestamp
  txHash: createdTxHash
  redeemedTxHash
  redeemedAt: redeemedBlockTimestamp
  affiliate
  isRedeemed
  isRedeemable
  isCashedOut
  core {
    address
    liquidityPool {
      address
    }
  }
  selections {
    odds
    result
    outcome {
      outcomeId
      title
      condition {
        conditionId
        status
        title
        wonOutcomeIds
        game {
          id
          gameId
          title
          startsAt
          status
          slug
          sport {
            sportId
            slug
            name
            sporthub {
              id
              slug
            }
          }
          league {
            id
            slug
            name
            country {
              id
              slug
              name
            }
          }
          participants {
            image
            name
          }
        }
      }
    }
  }
  freebet {
    freebetId
    contractAddress: freebetContractAddress
  }
  cashout {
    payout
  }
}
    `;